import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/container_channel/common/client/utils/formatImg';
import { formatDateTime } from '../../../utils/index';

/**
 * for this page
 */

class ImgNewsWrapper extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        formatTitle: PropTypes.bool,
    };

    static defaultProps = {
        formatTitle: false,
    };

    render() {
        // console.log('imgNewsWrapper=', this.props);
        /**
         * 组件分发数据
         */
        const { content, formatTitle } = this.props;

        const handleFormatTitle = title => {
            if (title) {
                let tagetIndex = 0;

                if (title.indexOf('|') > 0) {
                    tagetIndex = title.indexOf('|') + 1;
                } else if (title.indexOf('丨') > 0) {
                    tagetIndex = title.indexOf('丨') + 1;
                }

                return title.substring(tagetIndex);
            } else {
                return title;
            }
        };

        const itemWrapper = item => {
            const title = formatTitle ? handleFormatTitle(item.title) : item.title;

            return (
                <div className={styles.listItem} key={item.id}>
                    <div className={styles.pic}>
                        <a href={item.url} target="_blank">
                            <img
                                src={formatImage(item.thumbnails.image[0].url, 286, 196)}
                                title={title}
                                alt={item.title}
                            />
                        </a>
                        {/* 角标 */}
                        <div className={item.page ? styles.num : styles.hide}>
                            <a href={item.url} target="_blank">
                                {item.page}
                            </a>
                        </div>
                    </div>
                    <h3>
                        <a href={item.url} target="_blank">
                            {title.length > 16 ? `${title.slice(0, 16)}...` : title}
                        </a>
                    </h3>
                    <p>{formatDateTime(item.newsTime, 1)}</p>
                </div>
            );
        };

        return (
            <div className={styles.imgNewsWrapper}>
                <div className={`clearfix ${styles.list}`}>
                    {content.map(item => {
                        return itemWrapper(item);
                    })}
                </div>
            </div>
        );
    }
}

export default errorBoundary(ImgNewsWrapper);
